/* eslint-disable */
export const OWNER = 'OWNER';
export const GUEST = 'GUEST';
export const PASSING = 'PASSING';
export const GREETING_NAME_CHUNGVUI = 'CEO ChungVui';
export const GREETING_CONTENT_CHUNGVUI = 'Chúc mừng hai bạn đã tìm thấy nhau. Chúc hai bạn mãi mãi hạnh phúc và viên mãn trên hành trình mới. Cảm ơn hai bạn đã tin tưởng và chọn ChungVui để khởi đầu câu chuyện đẹp của mình.';
